import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { StudentGrid } from '../../services/model/student-grid';
import { StudentGridActions } from '../actions/student-grid.actions';


export const studentGridAdapter: EntityAdapter<StudentGrid> = createEntityAdapter<StudentGrid>({
  selectId: (studentGrid: StudentGrid) => studentGrid.id!,
});

export interface StudentGridState {
  studentGrids: EntityState<StudentGrid>;
}

export const initialStudentGridState: StudentGridState = {
  studentGrids: studentGridAdapter.getInitialState(),
};

export const studentGridFeature = createFeature({
  name: 'studentGrid',
  reducer: createReducer(
    initialStudentGridState,
    on(StudentGridActions.studentGridsLoaded, (state, { studentGrids }) => ({
      ...state,
      studentGrids: studentGridAdapter.upsertMany(studentGrids, state.studentGrids),
    })),
    on(StudentGridActions.studentGridAdded, (state, { studentGrid }) => ({
      ...state,
      studentGrids: studentGridAdapter.addOne(studentGrid, state.studentGrids),
    })),
    on(StudentGridActions.studentGridCoursesAdded, (state, { studentGridId, organizedCourseIds }) => ({
      ...state,
      studentGrids: studentGridAdapter.updateOne({
        id: studentGridId,
        changes: {
          organizedCourses: organizedCourseIds.map((organizedCourseId) => ({ id: organizedCourseId }))
        }
      }, state.studentGrids),
    })),
    on(StudentGridActions.studentGridCourseRemoved, (state, { studentGridId, organizedCourseId }) => ({
      ...state,
      studentGrids: studentGridAdapter.updateOne({
        id: studentGridId,
        changes: {
          organizedCourses: state.studentGrids.entities[studentGridId]?.organizedCourses?.filter((organizedCourse) => organizedCourse.id !== organizedCourseId)
        }
      }, state.studentGrids),
    })),
    on(StudentGridActions.studentGridCourseAdded, (state, { studentGridId, organizedCourseId }) => ({
      ...state,
      studentGrids: studentGridAdapter.updateOne({
        id: studentGridId,
        changes: {
          organizedCourses: [...(state.studentGrids.entities[studentGridId]?.organizedCourses || []), { id: organizedCourseId }]
        }
      }, state.studentGrids),
    })),
    on(StudentGridActions.reset, () => initialStudentGridState),
  ),
});